import { useState } from "react";
import { useSelector } from "react-redux";
import { basics } from "../../../basics";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { cartActions } from "../../../store/cart-slice";
import PurchaseInvoicePrices from "./PurchaseInvoicePrices";
import FinalSubmitAndPay from "../../Ui/FinalSubmitAndPay";
import ListOfCartItemsInCarInProfile from "./ListOfCartItemsInCartInProfile";
import CouponDiscount from "./CouponDiscount";
import { uiActions } from "../../../store/Ui-slice";
import YourCartIsEmpety from "./YourCartIsEmpety";
import { MdDelete, MdShoppingCart, MdSupportAgent } from "react-icons/md";
import {
  HiOutlineClipboardList,
  HiOutlineLocationMarker,
} from "react-icons/hi";
import { IoIosArrowDown } from "react-icons/io";
import {
  IoShieldCheckmarkOutline,
  IoLockClosedOutline,
  IoPricetagOutline,
} from "react-icons/io5";
import { FaTruck } from "react-icons/fa";
import shopLogo from "../../../resources/images/app/ic_icon.png";

const CartInProfile = () => {
  const dispatch = useDispatch();
  const [showCoupon, setShowCoupon] = useState(false);

  const cartItems = useSelector((state: any) => state.cart.items.items);
  const cart = useSelector((state: any) => state.cart);
  const LoggedIn = useSelector((state: any) => state.auth.isLoggedIn);
  const history = useHistory();

  const firstName = useSelector((state: any) => state.userInfo.firstName);
  const lastName = useSelector((state: any) => state.userInfo.lastName);
  const phoneNumber = useSelector((state: any) => state.auth.phoneNumber);

  const finalSbmitHandler = () => {
    if (Object.keys(cartItems).length) {
      if ((firstName || lastName) && phoneNumber) {
        history.push("/selectAddressAndAcceptPrices");
      } else {
        dispatch(uiActions.toggleUpdateUserModal());
        dispatch(
          uiActions.showNotification({
            status: "error",
            title: "تکمیل پروفایل",
            message: "لطفا نام و نام خانوادگی خود را وارد کنید",
          })
        );
      }
      // TODO:in this function I should make sure that my cart items is avalible in server or not
    } else {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "سبد خالی است",
          message: "",
        })
      );
    }
  };

  if (!LoggedIn) {
    dispatch(uiActions.toggleModal());
    history.push("/");
  }
  if (!Object.keys(cartItems).length) {
    return <YourCartIsEmpety />;
  }
  const eraseAllItemsHandler = () => {
    dispatch(cartActions.eraseAllCart());
  };

  const numberOfCartItemsNonZero =
    cart.totalQuantity !== 0 && cart.totalQuantity;

  return (
    <>
      {/* fixed mobile header: cart icon (right) - logo (center) - delete icon (left)
          offset below top-12 to clear the app's global fixed back-button strip */}
      <div className="fixed inset-x-0 top-12 z-10 border-b border-slate-100 bg-white/95 px-3 py-3 backdrop-blur sm:hidden">
        <div className="flex items-center justify-between">
          <div className="relative">
            {numberOfCartItemsNonZero !== false && (
              <span className="absolute -right-1.5 -top-1.5 z-10 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-rose-600 px-1 text-[11px] font-bold text-white shadow-sm">
                {numberOfCartItemsNonZero}
              </span>
            )}
            <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-slate-100 bg-white text-slate-600 shadow-sm">
              <MdShoppingCart className="h-6 w-6" />
            </div>
          </div>

          <div className="flex flex-1 flex-col items-center">
            <img src={shopLogo} alt="" className="h-10" />
            <span className="mt-1 text-xs font-bold text-gray-700">
              {basics.ListOfOrdersInCart}
            </span>
          </div>

          <button
            onClick={eraseAllItemsHandler}
            className="flex h-11 w-11 items-center justify-center rounded-xl border border-slate-100 bg-white text-slate-600 shadow-sm transition hover:text-rose-600"
          >
            <MdDelete className="h-6 w-6" />
          </button>
        </div>
      </div>

      {/* fixed desktop header (sits below the global TopNavbar): title (right) - icon cluster (left) */}
      <div className="fixed inset-x-0 top-16 z-10 hidden border-b border-slate-100 bg-white/95 px-6 py-3 backdrop-blur sm:block lg:px-8">
        <div className="mx-auto flex max-w-6xl items-center justify-between">
          <span className="text-xl font-extrabold text-gray-800">
            {basics.ListOfOrdersInCart}
          </span>

          <div className="flex items-center gap-2">
            <div className="relative">
              {numberOfCartItemsNonZero !== false && (
                <span className="absolute -right-1.5 -top-1.5 z-10 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-rose-600 px-1 text-[11px] font-bold text-white shadow-sm">
                  {numberOfCartItemsNonZero}
                </span>
              )}
              <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-slate-100 bg-white text-slate-600 shadow-sm">
                <MdShoppingCart className="h-6 w-6" />
              </div>
            </div>
            <button
              onClick={eraseAllItemsHandler}
              className="flex h-11 w-11 items-center justify-center rounded-xl border border-slate-100 bg-white text-slate-600 shadow-sm transition hover:text-rose-600"
            >
              <MdDelete className="h-6 w-6" />
            </button>
          </div>
        </div>
      </div>

      <div className="mx-auto mb-24 max-w-6xl px-3 pt-[140px] sm:px-6 sm:pt-[152px] lg:px-8">
        <div className="flex items-center justify-center gap-2 rounded-xl bg-emerald-50 px-3 py-2.5 text-xs font-bold text-emerald-700 sm:hidden">
          <IoShieldCheckmarkOutline className="h-4 w-4 shrink-0" />
          <span>خرید شما کاملاً امن و محافظت شده است</span>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-6 lg:grid-cols-[360px_1fr]">
          <div className="order-2 h-fit rounded-2xl border border-slate-100 bg-white p-4 shadow-sm sm:p-5 lg:sticky lg:top-36 lg:order-1">
            <div className="mb-3 flex items-center gap-2">
              <HiOutlineClipboardList className="h-5 w-5 text-slate-400" />
              <h2 className="text-base font-extrabold text-gray-900">
                خلاصه سفارش
              </h2>
            </div>

            <PurchaseInvoicePrices />

            <div onClick={finalSbmitHandler} className="mt-4">
              <FinalSubmitAndPay
                title={basics.continueProcessOfPurchase}
                className="flex w-full items-center justify-center gap-2 rounded-xl bg-rose-700 py-3 text-sm font-bold text-zinc-50 shadow-sm transition hover:bg-rose-800"
              />
            </div>

            <div className="mt-4 space-y-3 border-t border-slate-100 pt-4">
              <div className="flex items-center gap-3">
                <FaTruck className="h-6 w-6 shrink-0 text-emerald-600" />
                <div>
                  <p className="text-xs font-bold text-gray-900">ارسال سریع</p>
                  <p className="text-[11px] text-gray-500">
                    ارسال در کمتر از ۲۴ ساعت
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <IoShieldCheckmarkOutline className="h-6 w-6 shrink-0 text-emerald-600" />
                <div>
                  <p className="text-xs font-bold text-gray-900">ضمانت کیفیت</p>
                  <p className="text-[11px] text-gray-500">
                    ضمانت بازگشت کالا در صورت عدم رضایت
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <IoLockClosedOutline className="h-6 w-6 shrink-0 text-emerald-600" />
                <div>
                  <p className="text-xs font-bold text-gray-900">پرداخت امن</p>
                  <p className="text-[11px] text-gray-500">
                    اطلاعات شما کاملاً محفوظ است
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="mb-3 hidden items-center gap-2 sm:flex">
              <span className="rounded-full bg-slate-100 px-2.5 py-1 text-xs font-bold text-slate-500">
                {`${cartItems.length} کالا`}
              </span>
              <h1 className="text-xl font-extrabold text-gray-900">
                سبد خرید شما
              </h1>
            </div>

            <ListOfCartItemsInCarInProfile />

            <button
              onClick={() => setShowCoupon((prev) => !prev)}
              className="mt-3 flex w-full items-center justify-between rounded-xl border border-dashed border-rose-200 bg-rose-50/50 px-4 py-3 text-sm font-bold text-rose-600"
            >
              <span>کد تخفیف دارید؟ وارد کنید</span>
              <IoIosArrowDown
                className={`h-4 w-4 transition-transform ${
                  showCoupon ? "rotate-180" : ""
                }`}
              />
            </button>
            {showCoupon && (
              <div className="mt-2">
                <CouponDiscount />
              </div>
            )}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4">
          <div className="flex flex-col items-center gap-1.5 rounded-xl border border-slate-100 bg-white p-3 text-center shadow-sm">
            <MdSupportAgent className="h-6 w-6 text-emerald-600" />
            <p className="text-xs font-bold text-gray-900">پشتیبانی ۲۴/۷</p>
            <p className="text-[11px] text-gray-500">پشتیبانی در تمام روزها</p>
          </div>
          <div className="flex flex-col items-center gap-1.5 rounded-xl border border-slate-100 bg-white p-3 text-center shadow-sm">
            <IoShieldCheckmarkOutline className="h-6 w-6 text-emerald-600" />
            <p className="text-xs font-bold text-gray-900">ضمانت بازگشت کالا</p>
            <p className="text-[11px] text-gray-500">تا ۷ روز ضمانت بازگشت</p>
          </div>
          <div className="flex flex-col items-center gap-1.5 rounded-xl border border-slate-100 bg-white p-3 text-center shadow-sm">
            <HiOutlineLocationMarker className="h-6 w-6 text-emerald-600" />
            <p className="text-xs font-bold text-gray-900">
              ارسال به سراسر کشور
            </p>
            <p className="text-[11px] text-gray-500">ارسال به تمام نقاط ایران</p>
          </div>
          <div className="flex flex-col items-center gap-1.5 rounded-xl border border-slate-100 bg-white p-3 text-center shadow-sm">
            <IoPricetagOutline className="h-6 w-6 text-emerald-600" />
            <p className="text-xs font-bold text-gray-900">بهترین قیمت</p>
            <p className="text-[11px] text-gray-500">تضمین بهترین قیمت بازار</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CartInProfile;
